import { Store } from 'vuex'
import { SubmissionFileType } from '@/types'

export class DasService {
  static async uploadFile(store: Store<unknown>, file: File): Promise<void> {
    return store.dispatch('uploadFile', { fileType: SubmissionFileType.DAS, file })
  }

  static async uploadDas(store: Store<unknown>, submissionId: string, content: string, tempId: string): Promise<void> {
    return store.dispatch('uploadDas', { submissionId, content, tempId })
  }

  static async deleteFile(store: Store<unknown>, fileId: string): Promise<void> {
    return store.dispatch('deleteFile', fileId)
  }
}
